import { render } from "./CvCard008.vue?vue&type=template&id=9a984094&scoped=true"
import script from "./CvCard008.vue?vue&type=script&lang=js"
export * from "./CvCard008.vue?vue&type=script&lang=js"

import "./CvCard008.vue?vue&type=style&index=0&id=9a984094&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a984094"]])

export default __exports__